import { render } from "./FullStackPage.vue?vue&type=template&id=2e2bc29b"
import script from "./FullStackPage.vue?vue&type=script&lang=js"
export * from "./FullStackPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__